import * as React from 'react';
import styles from './risk-evaluation-timeline.scss';
import { Badge } from 'ui/badge/badge';
import { useEffect } from 'react';
import { RiskEvaluationTimelineItem } from 'app/area/case/components/loss-potential/risk-evaluation-timeline/types';
import { useQueryParams } from 'app/area/shared/navigation';
import { tableName } from 'app/area/case/case-data-model';
export interface RiskEvaluationTimelineProps {
  id: string;
  items: RiskEvaluationTimelineItem[];
  selectedItem: RiskEvaluationTimelineItem;
  onClick?: (item: RiskEvaluationTimelineItem) => void;
  className?: string;
  showTooltip?: boolean;
  shouldAnimateOnAdd?: boolean;
  hideRiskWeight?: boolean;
}

export const RiskEvaluationTimeline = (props: RiskEvaluationTimelineProps): JSX.Element => {
  const { id, className, items, onClick, showTooltip, shouldAnimateOnAdd, hideRiskWeight } = props;
  let ref: HTMLElement;
  const addRef = (el: HTMLElement) => ref = el;
  const MAX_LENGTH_DATE = 20;

  useEffect(() => {
    document.getElementById(id).scrollLeft = ref?.offsetLeft - 100;
  });

  const isActive = (item: RiskEvaluationTimelineItem) => {
    return JSON.stringify(props.selectedItem) === JSON.stringify(item?.entityPath);
  };

  const handleOnClick = (item: RiskEvaluationTimelineItem) => (e: any) => {
    e.preventDefault();
    onClick?.(item);
  };

  const formattedDate = (date: string) => {
    const truncatedText = date?.substring(0, MAX_LENGTH_DATE);
    return date?.length > MAX_LENGTH_DATE ? truncatedText + '...' : date;
  };

  const isLossPotential = !!useQueryParams().query.addLossPotential;
  const isResidual = !!useQueryParams().query.addResidual;

  const animateItem = (item: RiskEvaluationTimelineItem): boolean => {
    if (!shouldAnimateOnAdd) {
      return false;
    }
    return isLossPotential && item?.entityPath[item?.entityPath.length - 1].hasOwnProperty(tableName.lossPotentialEvaluation) ||
      isResidual && item?.entityPath[item?.entityPath?.length - 1].hasOwnProperty(tableName.lossPotentialResidualEvaluation);
  };

  return <>
    <ul id={id} className={`d-flex justify-content-start ${className} ${styles.riskEvaluationTimeline}`}>
      {items?.map((item, index) => {
        const text = hideRiskWeight ? '' : item?.text;

        return <li key={index}
          className={`${styles.timelineWrapper} ${isActive(item) && animateItem(item) ? styles.animateItem : ''}`}
          onClick={(handleOnClick(item))} ref={isActive(item) ? addRef : undefined}>
          <a className={`${styles.timelineContainer} ${!item.url ? styles.unlinkedItem : ''}`} href={item.url || undefined}>
            <span className={`${styles.timelineDate} ${isActive(item) ? styles.activeItem : ''}`}
              data-testid={`${isActive(item) ? 'ActiveItem' : ''}`}>
              {formattedDate(item?.date)}
            </span>
            <span className={styles.badgeContainer}>
              <Badge
                backgroundColor={item?.backgroundColor}
                foregroundColor={item?.foregroundColor}
                showTooltip={showTooltip}
                tooltip={item?.tooltip}
                text={text}
                filled={item?.filled}
                riskTrend={item?.riskTrend} />
            </span>
          </a>
        </li>;
      })}
    </ul>
  </>;
};
